var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sys-teacher-hub-modal",
    {
      attrs: {
        show: _vm.show,
        title: _vm.title,
        icon: _vm.icon,
        "max-width": "980",
      },
      on: {
        "update:show": function ($event) {
          return _vm.$emit("update:show", $event)
        },
      },
    },
    [
      _c(
        "v-card-text",
        { staticClass: "pa-2" },
        [
          _c("sys-teacher-discipline", {
            attrs: {
              teacher: _vm.teacher,
              token: _vm.token,
              text: _vm.teacher?.realInstitution?.text_interest || null,
            },
            on: { onComplete: _vm.handleOnComplete },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }